<template lang="pug">
    #app.app(v-on:mousemove='move')
        button.dbgbot(v-if='dev',v-on:click='generate_atlas') Generate Atlas
        svg.atlas_svg(xmlns="http://www.w3.org/2000/svg" version="1.1" ref="svg")
            filter#grayscale
                feColorMatrix(type="matrix" values="0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0")
            g(ref='wrapper')
                g#bg(fill='none')
                    image(:xlink:href="atlas_image" x="0" y="0" width="177" height="100")
                g(fill='none')
                    sextant(v-for='s in sextants' :key='s.id' :sextant='s' :pos='positions[s.id]' :ref='ref("sext",s.id)')
                g(fill='none',ref='maps')
                    atlas-map(v-for='m in maps' :key='m.id' :map='m' :pos='positions[m.id]' :ref='ref("map",m.id)')
        search
        sextants-menu(ref='menu' :maps='maps',:sextants='sextants')
        my-footer
        help-modal(ref='help_modal' v-show='show_help' @close_modal="show_help = false")

</template>

<script>
    import svgPanZoom from 'svg-pan-zoom'
    import * as atlas from './atlas'
    import * as url_safe64 from 'url-safe-base64'
    import * as base from 'base-64'
    import * as utf from 'utf8'
    // import * as original from './original_atlas'
    import AtlasMap from './components/AtlasMap'
    import Sextant from './components/Sextant'
    import Search from './components/Search'
    import SextantsMenu from './components/SextantsMenu'
    import MyFooter from './components/MyFooter'
    import HelpModal from './components/modals/HelpModal'

    export default {
        name: 'app'
        , components: {AtlasMap, Sextant, Search, SextantsMenu, MyFooter, HelpModal}
        , data() {
            let coords = atlas.coords();
            let maps = atlas.maps();

            let dev = false;
            let sextants = atlas.sextants();
            if (dev === true)
                sextants = this.generate_sextants(maps, coords);

            for (let map of Object.values(maps)) {
                map['locked_sextant'] = 0;
                map['selected'] = false;
                map['shaped'] = false;
                map['complete'] = true;
                map['highlighted'] = false;

            }

            for (let sextant of Object.values(sextants)) {
                sextant['visible'] = false;
                sextant['level'] = 0;
            }

            let atlas_image = 'img/atlas.jpg';
            // if (!IS_DEV)
            //     atlas_image = '//web.poecdn.com/image/Art/2DArt/Atlas/Atlas.png';
            if (!IS_DEV)
                atlas_image = '//i.imgur.com/aApWFqG.jpg';

            return {
                atlas_image: atlas_image,
                positions: coords,
                maps: maps,
                sextants: sextants,
                dev: dev,
                dragging: null,
                show_help: false
            };
        }
        , methods: {
            ref(type, id) {
                return `${type}-${id}`;
            }
            , show_sextants() {
                this.show_help = true;
                this.$refs.help_modal.show_sextants();
            }
            , show_commands() {
                this.show_help = true;
                this.$refs.help_modal.show_commands();
            }
            , distance(a, b) {
                return Math.sqrt(Math.pow(a.x - b.x, 2) + Math.pow(a.y - b.y, 2));
            }
            , drag(map) {
                if (!this.dev)
                    return;
                if (map !== null)
                    this.pan_map.disablePan();
                else {
                    this.sextants = this.generate_sextants(this.maps, this.positions);
                    this.pan_map.enablePan();
                }
                this.dragging = map;
            }
            , move(ev) {
                if (this.dev && this.dragging !== null) {
                    let pt = this.cursorPoint(ev);
                    let id = this.dragging.id;
                    this.positions[id].x = pt.x;
                    this.positions[id].y = pt.y;
                }
            }
            , zoom_to_map(map_id) {
                let x = this.positions[map_id].x;
                let y = this.positions[map_id].y;

                this.pan_map.zoom(4);
                let s = this.pan_map.getSizes();
                let w = s.width;
                let h = s.height;
                let z = s.realZoom;

                this.pan_map.pan({x: -x * z + w / 2, y: -y * z + h / 2})
            }
            , cursorPoint(evt) {
                let wrapper = this.$refs.wrapper;
                let pt = this.$refs.svg.createSVGPoint();
                pt.x = evt.clientX;
                pt.y = evt.clientY;
                return pt.matrixTransform(wrapper.getScreenCTM().inverse());
            }
            , generate_sextants(maps, coords) {
                let sextants = {};
                for (let map of Object.values(this.maps)) {
                    let list = [];
                    for (let next of Object.values(this.maps)) {
                        let pa = coords[map.id];
                        let pb = coords[next.id];
                        if (map.id !== next.id && this.distance(pa, pb) < 9.75)
                            list.push(next.id);
                    }
                    sextants[map.id] = {id: map.id, level: 0, near: list, visible: false};
                }
                return sextants;
            }
            , calculate_sextants() {

                // clear all sextants
                for (let sextant of Object.values(this.sextants)) {
                    sextant.level = 0;
                    sextant.visible = false;
                }

                // blue sextants
                for (let map of Object.values(this.maps)) {
                    if (map.selected)
                        this.sextants[map.id].visible = true;
                }

                // other levels
                for (let i = 1; i < 4; i++) {
                    // for each level find the ones needed
                    let to_show = [];
                    for (let sextant of Object.values(this.sextants)) {
                        if (sextant.visible) {
                            for (let n of sextant.near) {
                                if (this.sextants[n].visible === false && to_show.indexOf(n) < 0 && this.maps[n].complete) {
                                    to_show.push(n);
                                }
                            }
                        }
                    }

                    // and then apply them, we don't modify the array while searching.
                    for (let s of to_show) {
                        this.sextants[s].visible = true;
                        this.sextants[s].level = i;
                    }
                }
            }
            , generate_atlas() {
                let pos_txt = JSON.stringify(this.positions);
                let sex_txt = JSON.stringify(this.sextants);
                let map_txt = JSON.stringify(this.maps);
                console.log(`export function maps(){ return ${map_txt} } export function coords(){ return ${pos_txt} } export function sextants(){ return ${sex_txt} }`)
            }
            , generate_url() {
                let maps_res = {};
                for (let map of Object.values(this.maps)) {
                    let mr = {};
                    if (!map.complete) {
                        mr['c'] = false;
                    }
                    if (map.shaped) {
                        mr['s'] = true;
                    }
                    if (map.locked_sextant > 0) {
                        mr['ls'] = map.locked_sextant;
                    }
                    if (Object.keys(mr).length > 0) {
                        maps_res[map.id] = mr;
                    }
                }

                if (Object.keys(maps_res).length > 0) {
                    let res = {'v': '1.0.0', maps: maps_res};
                    let j = utf.encode(JSON.stringify(res));
                    location.hash = url_safe64.encode(base.encode(j));
                } else {
                    location.hash = '';
                }
            }
        }
        ,
        watch: {
            maps: {
                handler() {
                    this.calculate_sextants();
                    this.generate_url()
                }
                ,
                deep: true
            }
        }
        ,
        created() {
            let query = location.hash.replace('#', '');
            if (query.length > 0) {
                try {
                    let res = JSON.parse(utf.decode(base.decode(url_safe64.decode(query))));
                    for (let [i, m] of Object.entries(res.maps)) {
                        if (m.c !== undefined) {
                            this.maps[i].complete = m.c;
                        }
                        if (m.s !== undefined) {
                            this.maps[i].shaped = m.s;
                        }
                        if (m.ls !== undefined) {
                            this.maps[i].locked_sextant = m.ls;
                        }
                    }
                } catch (ex) {
                }
            }
        }
        ,
        mounted() {
            this.pan_map = svgPanZoom(this.$refs.svg, {
                zoomEnabled: true,
                minZoom: 1,
                maxZoom: 6,
                zoomScaleSensitivity: 0.5,
                fit: true,
                contain: true,
                center: true,
                controlIconsEnabled: true
            });
            window.pan_map = this.pan_map;
        }
    }
</script>

<style lang="scss">

    g.svg-pan-zoom-control {
        display: none;
    }
</style>
<style lang="scss" scoped>
    @import 'variables.scss';

    .app {
        height: 100%;
        .atlas_svg {
            display: inline;
            width: 100%;
            height: 100%;
        }
    }

    .dbgbot {
        position: absolute;
        top: 0;
        right: 0;
    }
</style>


// WEBPACK FOOTER //
// src/App.vue